var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_3553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4149 42.7043L44.5836 52.0632H37.4355L40.7885 42.7043H41.4149ZM58.5114 57.0743H53.2793V58.9166H66.1754V57.0743H61.0169V42.3359H66.1754V40.4936H53.2793V42.3359H58.5114V57.0743ZM34.9668 58.9166L36.7354 53.9792H45.2468L46.9049 58.9166H49.6315L42.9992 40.4936H39.2409L32.4981 58.9166H34.9668ZM76.4554 76.4553H23.5446V23.5444H76.4554V76.4553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1584 99.9998C78.7768 97.5679 97.5684 78.7765 100 55.1582H93.7732C91.5624 75.6446 76.0502 91.9673 55.1584 94.2886V99.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 55.1582C2.43184 78.7765 21.2233 97.5679 44.8416 99.9998V94.2886C23.9499 91.9673 8.47458 75.6077 6.22697 55.1582H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 44.8416C97.5684 21.2233 78.7768 2.43183 55.1584 0V5.71113C76.0502 8.03242 91.5256 24.392 93.7732 44.8416H100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8415 0C21.2233 2.43183 2.43183 21.2233 0 44.8415H6.22697C8.43773 24.3552 23.9499 8.03242 44.8415 5.71113V0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_3553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIc);
export default __webpack_public_path__ + "static/media/ai_ic.92bb590f37cd1dbea0c0cfb60d81e0fa.svg";
export { ForwardRef as ReactComponent };